export default "__VITE_ASSET__CkQfFYSy__"